"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Stepper = _interopRequireDefault(require("@mui/material/Stepper"));
var _StepConnector = _interopRequireDefault(require("@mui/material/StepConnector"));
var _styles = _interopRequireDefault(require("../styles"));
var _EDSContext = require("./../EDSContext/EDSContext");
var _Typography = _interopRequireDefault(require("../Typography"));
var _constants = require("./internal/constants.js");
var _tokens = require("../styles/tokens");
var _StepProgressContext = _interopRequireDefault(require("./internal/StepProgressContext"));
var _makeStylesInternal = _interopRequireDefault(require("../makeStyles/makeStylesInternal"));
var _lodash = require("lodash");
var _excluded = ["classes", "edsContext", "connector", "orientation"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = function styles() {
  return {
    root: {
      background: 'transparent',
      padding: _tokens.spacing50
    },
    expansionless: {
      '& > div:first-child': {
        paddingLeft: '0px'
      },
      '& > div:last-child': {
        paddingRight: '0px'
      }
    }
  };
};
var useStyles = (0, _makeStylesInternal.default)(function () {
  return {
    root: {
      padding: "0 0 " + _tokens.spacing30,
      marginLeft: '0.75rem',
      minHeight: _tokens.spacing50
    }
  };
});
var ExpansionConnector = function ExpansionConnector() {
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  });
};

/**
 * Use `StepProgress` to display a user's progress through numbered steps.
 * @done true
 * @updated v7.5.0
 * @versionAdded v0.0.14
 * @examples
 *  LinearHorizontalExample
 *  NonLinearExample
 *  AlternativeLabelExample
 *  VerticalExample
 *  ErrorStateExample
 *  MobileStepperExample
 *  NonLinearDisabledExample
 *  VerticalExpansionExample
 */
var StepProgress = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _cn;
  var _useState = (0, _react.useState)(''),
    stepLabel = _useState[0],
    setStepLabel = _useState[1];
  var _useState2 = (0, _react.useState)(false),
    hasStepError = _useState2[0],
    setHasStepError = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    errorLabel = _useState3[0],
    setErrorLabel = _useState3[1];
  var localRef = ref || (0, _react.useRef)(); //eslint-disable-line react-hooks/rules-of-hooks
  var classes = props.classes,
    edsContext = props.edsContext,
    connector = props.connector,
    orientation = props.orientation,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var classOverrides = {
    root: (0, _classnames.default)(classes.root, (_cn = {}, _cn[classes.expansionless] = orientation !== 'vertical-expansion', _cn))
  };

  // These labels are used to add aria-label attribute.
  // First selector (with button) is used to get reference of StepButton to update/read aria label.
  // Second selector is used to get reference of StepLabel to update/read aria label.
  // We added button selector to address StepButton NVDA issue.
  var getStepLabels = function getStepLabels() {
    var stepLabels = localRef.current.querySelectorAll("." + _constants.STEP_PROGRESS_STEP_CLASSNAME + " > button");
    if (stepLabels.length <= 0) {
      stepLabels = localRef.current.querySelectorAll("." + _constants.STEP_LABEL_CLASSNAME);
    }
    return stepLabels;
  };

  // This effect sets the `aria-label` to say `<step-label>, <step-number> / <total-steps>
  // by the screen reader by extracting all the step labels
  (0, _react.useEffect)(function () {
    var activeStep = props.activeStep;
    var stepLabels = getStepLabels();
    stepLabels.forEach(function (localStepLabel, i) {
      var stepLabelKey = i === activeStep ? 'component.StepProgress.a11yLabelSelected' : 'component.StepProgress.a11yLabel';
      localStepLabel.setAttribute('aria-label', edsContext.formatMessage(stepLabelKey, {
        label: localStepLabel.textContent.replace(/^[0-9]/, ''),
        step: i + 1,
        totalSteps: stepLabels.length
      }));
      localStepLabel.setAttribute('data-step-number', edsContext.formatMessage('component.StepProgress.errorOnStepLabel', {
        number: i + 1
      }));
    });
  }, [localRef, edsContext]);

  // This effect sets the div with current step content with error message if there is one.
  (0, _react.useEffect)(function () {
    try {
      var stepLabels = getStepLabels();
      var activeStep = stepLabels[props.activeStep];
      var localStepLabel = localRef.current.querySelectorAll("." + _constants.STEP_PROGRESS_STEP_CLASSNAME)[props.activeStep];
      var localErrorLabel = localStepLabel && localStepLabel.querySelector("." + _constants.STEP_LABEL_ERROR_CLASSNAME);
      var secondaryLabel = localErrorLabel ? localErrorLabel.textContent : '';
      setHasStepError(activeStep ? activeStep.classList.contains(_constants.STEP_LABEL_HAS_ERROR_CLASSNAME) : '');
      setErrorLabel(secondaryLabel);
      setStepLabel(props.activeStep + 1 > stepLabels.length ? edsContext.formatMessage('component.MobileStepper.allStepsCompleted') : activeStep && activeStep.getAttribute('aria-label'));
    } catch (error) {
      console.log(error);
    }
  }, [props.activeStep, localRef, edsContext]);
  var contextValue = _react.default.useMemo(function () {
    return {
      expansion: orientation === 'vertical-expansion',
      alternativeLabel: props.alternativeLabel
    };
  }, [orientation, props.alternativeLabel]);

  // Error message for the active step
  var getStepErrorMessage = function getStepErrorMessage() {
    var errorMessage = edsContext.formatMessage('component.StepProgress.errorMessage', {
      errorMessage: errorLabel
    });
    var text = stepLabel;
    text += hasStepError ? ", " + edsContext.formatMessage('component.StepProgress.errorMessageTitle') : '';
    text += errorLabel.length ? ", " + errorMessage : '';
    return text;
  };

  // All error messages to convey when user moves from one step to another
  // This is only when current step is not in error state.
  // If current step is in error state then current step's error message will take precedence.
  var getErrorMessagesForAllSteps = function getErrorMessagesForAllSteps() {
    if (hasStepError) {
      return '';
    }
    var text = '';
    var errors = localRef.current && localRef.current.querySelectorAll("." + _constants.STEP_LABEL_CONTAINER_CLASSNAME);
    if (errors && errors.length) {
      errors.forEach(function (error) {
        var label = error.querySelector("." + _constants.STEP_LABEL_HAS_ERROR_CLASSNAME);
        var number = label && label.getAttribute('data-step-number');
        var errorMessage = error.querySelector("." + _constants.STEP_LABEL_ERROR_CLASSNAME);
        if (label) {
          text += (number || '') + "," + (" " + (label.textContent || '') + ",") + (" " + (errorMessage ? errorMessage.textContent : '') + ". ");
        }
      });
    }
    return text ? edsContext.formatMessage('component.StepProgress.errors') + ", " + text : '';
  };
  var localConnector;
  if ((0, _lodash.isNil)(connector)) {
    localConnector = props.orientation === 'vertical-expansion' ? /*#__PURE__*/_react.default.createElement(ExpansionConnector, null) : /*#__PURE__*/_react.default.createElement(_StepConnector.default, null);
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_StepProgressContext.default.Provider, {
    value: contextValue
  }, /*#__PURE__*/_react.default.createElement(_Stepper.default, (0, _extends2.default)({}, rest, {
    connector: localConnector,
    orientation: orientation === 'vertical-expansion' ? 'vertical' : orientation,
    classes: classOverrides,
    ref: localRef
  })), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "srOnly",
    "aria-live": "assertive",
    className: _constants.ACTIVE_STEP_SCREEN_READER_TEXT
  }, getStepErrorMessage() + " " + getErrorMessagesForAllSteps())));
});
StepProgress.muiName = 'Stepper';
StepProgress.displayName = 'StepProgress';
StepProgress.propTypes = {
  /**
   * @ignore
   */
  edsContext: _propTypes.default.object,
  /**
   * Set the active step (zero based index).
   */
  activeStep: _propTypes.default.number,
  /**
   * If set to 'true' and orientation is `horizontal`,
   * then the step label will be positioned under the icon.
   */
  alternativeLabel: _propTypes.default.bool,
  /**
   * Two or more `<Step />` components.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,
  /**
   * @ignore
   */
  className: _propTypes.default.string,
  /**
   * A component to be placed between each step.
   */
  connector: _propTypes.default.element,
  /**
   * If set the `StepProgress` will not assist in controlling steps for linear flow.
   */
  nonLinear: _propTypes.default.bool,
  /**
   * The stepper orientation (layout flow direction).
   */
  orientation: _propTypes.default.oneOf(['horizontal', 'vertical', 'vertical-expansion']),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object, _propTypes.default.bool])), _propTypes.default.func, _propTypes.default.object])
};
StepProgress.defaultProps = {
  activeStep: 0,
  alternativeLabel: false,
  nonLinear: false,
  orientation: 'horizontal'
};
var _default = exports.default = (0, _EDSContext.withEDSContext)((0, _styles.default)(styles)(StepProgress));